import { type, value } from '@capital-access/common/user';

export class SelectedSecuritySettings {
  @value(type.number) id!: number | null;
}
